import { render, staticRenderFns } from "./GetPlan.vue?vue&type=template&id=6b23c7bb&scoped=true&"
import script from "./GetPlan.vue?vue&type=script&lang=js&"
export * from "./GetPlan.vue?vue&type=script&lang=js&"
import style0 from "./GetPlan.vue?vue&type=style&index=0&lang=less&"
import style1 from "./GetPlan.vue?vue&type=style&index=1&id=6b23c7bb&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b23c7bb",
  null
  
)

export default component.exports